export const FIND_TABLE_COLUMNS_CONFIG_FOR_USER_REQUEST = 'FIND_TABLE_COLUMNS_CONFIG_FOR_USER_REQUEST';

export const findTableColumnsConfigForUserRequest = (tableKey) => ({
  type: FIND_TABLE_COLUMNS_CONFIG_FOR_USER_REQUEST,
  payload: {
    tableKey
  }
});
